var $ = require('jquery');
var extend = require('extend');
var Magnific = require('magnific-popup');

function videoRegexInit(config) {
	var providerURL = /^(https?\:\/\/)?((www\.)?youtube\.com|vimeo\.com)\/.+$/;

	this.config = extend({
		anchors: document.querySelectorAll('a')
	}, config);

	var lightboxAnchors =
		$(this.config.anchors)
			.filter(function(index, element) {
				var hrefValue = element.getAttribute('href');

				// NOTE: Shortcircuit - latter only checks if former evaluates
				// as true -SB 5/2/2017
				return (
					providerURL.test(hrefValue)
						&& (hrefValue.indexOf('user') === -1)
				);
			});

	if (!lightboxAnchors.length) return;

	lightboxAnchors.magnificPopup({
		type: 'iframe',
		iframe: {
			patterns: {
				vimeo: {
					index: 'vimeo.com/',
					id: function(url) {
						var vimeoRegex = /^(?:https?\:\/\/)?(?:(?:www\.)?vimeo\.com)\/([0-9]+)/;
						return vimeoRegex.exec(url)[1];
					},
					src: '//player.vimeo.com/video/%id%?autoplay=1'
				}
			}
		}
	});
}

function videoInit() {
	var $videoElement = $('.lightboxVideo');
	if (!$videoElement.length)
		return;
	
	var lightboxVimeoCounter = 0;

	$videoElement.magnificPopup({
		type: 'iframe',
		iframe: {
			srcAction: 'iframe_src',
			patterns: {
				vimeo: {
					index: 'vimeo.com/',
					id: function(url) {
						var vimeoRegex = /^(?:https?\:\/\/)?(?:(?:www\.)?vimeo\.com)\/([0-9]+)/;
						return vimeoRegex.exec(url)[1];
					},
					src: '//player.vimeo.com/video/%id%?autoplay=1'
				},
				youtube: {
					index: 'youtube.com/',
					id: function(url) {
						var youtubeRegex = /youtu(?:.*\/v\/|.*v\=|\.be\/)([A-Za-z0-9_\-]{11})/;
						return youtubeRegex.exec(url)[1];
					},
					src: '//www.youtube.com/embed/%id%?enablejsapi=1&autoplay=1'
				}
			}
		},
		callbacks: {
			 markupParse: function(template, values, item) {
				var playerId = 'lightboxVimeo_' + lightboxVimeoCounter++;
				values.iframe_src = values.iframe_src + '&player_id=' + playerId;
				var iframe = template.find('iframe');
				iframe.attr('id', playerId);
			},
			open: function() {
				$(document).trigger('lightboxOpened');
			}
		}
	});

}

function imageInit() {
	var $imageElement = $('.lightboxImage');
	if (!$imageElement.length) return;

	$imageElement.magnificPopup({
		type: 'image'
	});
}

module.exports = {
	videoInit: videoInit,
	videoRegexInit: videoRegexInit,
	imageInit: imageInit
}
